import { cn } from '@/lib/cn';

/**
 * "Obi", the ObiGo mascot: a friendly expedition 4x4 seen from the front, whose
 * headlights are its eyes. Original artwork (no manufacturer marks). Decorative only.
 */
export function Mascot({
  className,
  mood = 'happy',
}: {
  className?: string;
  mood?: 'happy' | 'cheer' | 'think';
}) {
  const ink = '#1e2b24';
  return (
    <svg viewBox="0 0 120 120" aria-hidden className={cn('animate-float', className)}>
      <ellipse cx="60" cy="112" rx="44" ry="5" fill={ink} opacity="0.12" />
      {/* tyres */}
      <rect x="18" y="88" width="18" height="22" rx="6" fill={ink} />
      <rect x="84" y="88" width="18" height="22" rx="6" fill={ink} />
      {/* roof rack */}
      <path
        d="M28 14h64M34 14v6M46 14v6M60 14v6M74 14v6M86 14v6"
        stroke={ink}
        strokeWidth="3"
        strokeLinecap="round"
      />
      {/* cabin and windscreen */}
      <rect
        x="26"
        y="20"
        width="68"
        height="32"
        rx="7"
        fill="#e8e1cf"
        stroke={ink}
        strokeWidth="3"
      />
      <rect
        x="32"
        y="25"
        width="56"
        height="21"
        rx="5"
        fill="#bfe1ff"
        stroke={ink}
        strokeWidth="2.5"
      />
      <path
        d="M38 30l8-3M40 38l14-6"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
        opacity="0.8"
      />
      {/* snorkel */}
      <path
        d="M20 66V22a4 4 0 0 1 4-4h4"
        fill="none"
        stroke={ink}
        strokeWidth="4"
        strokeLinecap="round"
      />
      {/* body */}
      <rect
        x="14"
        y="48"
        width="92"
        height="44"
        rx="9"
        fill="#e8e1cf"
        stroke={ink}
        strokeWidth="3"
      />
      <rect x="14" y="78" width="92" height="6" fill="#4f7a43" />
      {/* grille */}
      <rect
        x="49"
        y="55"
        width="22"
        height="18"
        rx="3"
        fill="#cfc6b0"
        stroke={ink}
        strokeWidth="2"
      />
      <path d="M55 57v14M60 57v14M65 57v14" stroke={ink} strokeWidth="1.6" />
      {/* eyes = headlights */}
      <circle cx="33" cy="64" r="11" fill="white" stroke={ink} strokeWidth="3" />
      <circle cx="87" cy="64" r="11" fill="white" stroke={ink} strokeWidth="3" />
      <circle cx={mood === 'think' ? 30 : 35} cy={mood === 'think' ? 61 : 65} r="5" fill={ink} />
      <circle cx={mood === 'think' ? 84 : 89} cy={mood === 'think' ? 61 : 65} r="5" fill={ink} />
      <circle
        cx={mood === 'think' ? 32 : 37}
        cy={mood === 'think' ? 59 : 63}
        r="1.6"
        fill="white"
      />
      <circle
        cx={mood === 'think' ? 86 : 91}
        cy={mood === 'think' ? 59 : 63}
        r="1.6"
        fill="white"
      />
      {mood === 'think' && (
        <path d="M24 48l14 3M82 51l14-3" stroke={ink} strokeWidth="3" strokeLinecap="round" />
      )}
      {/* bumper smile */}
      <rect x="8" y="88" width="104" height="9" rx="4.5" fill={ink} />
      {mood === 'think' ? (
        <path d="M52 80h16" stroke={ink} strokeWidth="3" strokeLinecap="round" />
      ) : mood === 'cheer' ? (
        <path d="M48 76q12 12 24 0z" fill={ink} />
      ) : (
        <path d="M50 77q10 7 20 0" stroke={ink} strokeWidth="3" fill="none" strokeLinecap="round" />
      )}
      <circle cx="26" cy="77" r="3.5" fill="#ffd95a" opacity="0.8" />
      <circle cx="94" cy="77" r="3.5" fill="#ffd95a" opacity="0.8" />
    </svg>
  );
}
